import { Box, Link } from '@mui/material';
import { FC } from 'react';
import Text from './../../components/text';
import { getSite } from '@/lib/services/auth.service';

const PLATFORM_TERMS_OF_USE_URL =
  'https://cdn.sanity.io/media-libraries/mlg6Zwp8Ejtd/files/containers/3FbBDSr2cyPaDS4LOwLZAqsL5yY/f5-platform-terms-of-use.pdf';

const TermsOfService: FC = () => {
  const site = getSite();

  if (!site || !['admin', 'partner'].includes(site)) {
    return null;
  }

  return (
    <Box mt={2} mb={2}>
      <Text size="small" color="grey">
        By signing in, you agree to the F5 Workforce AI Security{' '}
        <Link href={PLATFORM_TERMS_OF_USE_URL} target="_blank">
          Platform Terms of Use
        </Link>
        .
      </Text>
    </Box>
  );
};

export default TermsOfService;
